import { IconButton } from '@mui/material';
import { useState } from 'react';
import { media } from '../../interfaces/interfaces';
import { createDisplayLink } from '../../services/helper';
import { downloadFileFromExternalLink } from '../../utils/functions';
import { ProgressBar } from '../common/ProgressBar';
import { MdDownload } from 'react-icons/md';

export const MediaDownloadButton = ({ media }: { media: media }) => {
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);

  let url = '';
  if (media.type === 'preuploadpresentation') url = media.path;
  else if (media.file) url = createDisplayLink(media.file);
  else if (media.type === 'meetingRecording' && media.playback_ids?.length === 1) url = `https://stream.mux.com/${media.playback_ids[0]?.id}/high.mp4`;
  else if (media.type === 'streamRecording' && media.playback_ids?.length === 1) url = `https://stream.mux.com/${media.playback_ids[0]?.id}/high.mp4`;

  function onProgress(progress: number) {
    setDownloadProgress(progress);
  }
  function onDownloadEnd() {
    // to show progress animation
    setTimeout(() => setIsDownloading(false), 2000);
  }
  function handleDownloadClick() {
    setIsDownloading(true);
    downloadFileFromExternalLink(url, media.name.replaceAll('.', '-'), onProgress, onDownloadEnd);
  }

  return (
    <div className="flex flex-col items-center justify-center w-full h-full min-h-[50px]">
      {!isDownloading ? (
        <IconButton color="secondary" onClick={handleDownloadClick} size="large" sx={{ background: 'white' }} disabled={media.isProcessing}>
          <MdDownload />
        </IconButton>
      ) : (
        <ProgressBar filled={downloadProgress} max={100} containerClassName="min-h-[50px]" />
      )}
    </div>
  );
};
